<template>
	<div class="recommend-company box-shadow">
		<div class="recommend-title">
			<img class="icon" src="../../assets/images/icon8.png" /> {{title}}
		</div>
		<div class="company-list">
			<template v-for="(item,index) in list">
				<div class="company-item" @click="tonextnew(item.id)">
					<!-- <el-avatar shape="square" :size="45"> {{item.company_name}} </el-avatar> -->
					<avatar-view :size="45" :name="item.company_name"></avatar-view>
					<div class="company-right">
						<div class="company-title text-cut1 margin-bottom-4"> {{item.company_name}}</div>
						<div class="margin-bottom-4">
							<el-tag class="bg-blueFF margin-right-8" effect="dark" size="mini ">
								{{item.industry||''}}
							</el-tag>
						</div>
						<div>
							<span class="city_str" v-if="type==2&&item.year">#{{item.year||''}}</span>
							<span class="city_str" v-if="item.city_str">#{{item.city_str||''}}</span>
							<span class="city_str" v-if="item.district_str">#{{item.district_str}}</span>
						</div>
					</div>
				</div>
			</template>
			<div v-if="list.length==0">
				<el-empty description="暂无数据" :image-size="100"></el-empty>
			</div>
		</div>
		<!-- v-if="list.length" -->
		<div class="menu-btn" @click="jump" v-if="list.length">
			查看更多<i class="el-icon-arrow-right"></i>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			type: {
				type: [Number, String],
				default: 1, //1企业库推荐 2政策库推荐
			},
			id: {
				type: [Number, String],
				default: 1, //企业或政策id
			},
			industry: {
				type: [Number, String],
				default: '', //企业或政策id
			},
			title: {
				type: String,
				default: "同行业企业推荐"
			}
		},
		data() {
			return {
				list: []
			}
		},
		methods: {
			getlist() {
				const that = this;
				this.$https.post({
						type: "formData",
						api: this.$api.api.interfacenew.get_company,
					}, {
						id: this.id,
						type: this.type
					},
					(res) => {
						that.list = res.data.list
					},
					(error) => {
						console.log(error);
					}
				);
			},
			jump() {
				this.$router.push({
					path: '/companystack',
					query: {
						industry: this.industry,
						rtype: this.type
					}
				});
			},
			tonextnew(id) {
				// console.log('idddddddd',id)
				// this.$router.push({ name: 'comdetail', query: { id: id } });
				let routeUrl = this.$router.resolve({
					name: "comdetail",
					query: {
						id: id
					}
				});

				window.open(routeUrl.href, "_blank");
			},
		},
		created() {
			this.getlist();
		}
	}
</script>

<style lang="scss" scoped>
	.recommend-company {
		width: 280px;
		background-color: #FFF;
		border-radius: 10px;

		.recommend-title {
			height: 50px;
			display: flex;
			align-items: center;
			padding: 0px 15px 0px 10px;
			font-size: 18px;
			font-weight: bold;

			.icon {
				width: 24px;
				height: 24px;
				margin-right: 8px;
			}
		}

		.company-list {
			.company-item {
				display: flex;
				border-top: solid #EEE 1px;
				padding: 15px 15px 10px;
				cursor: pointer;
			}

			.company-right {
				flex: 1;
				margin-left: 10px;
			}

			.company-title {
				font-size: 15px;
			}

			.city_str {
				// font-size: 14px;
				color: #AFACA8;
			}
		}

	}

	.menu-btn {
		color: #3290FD;
		cursor: pointer;
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top: 1px solid #eee;
	}
</style>



// WEBPACK FOOTER //
// recommend.vue?8517c7ec